import { useState } from "react"
import { studentRequest } from "services/requests"
import { useGlobalAlert } from "contexts/GlobalAlertContext"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const getStudentGroups = async () => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: "groups",
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  const getSelectedGroup = async () => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `groups/selected`,
      body: null,
      method: "get",
    })
    if (!response.success) {
      showAlert(response.message)
    }
    setIsFetching(false)
    return response.data
  }

  const getStudentGroupsSummary = async ({ controller }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `groups/missionsSummary`,
      body: null,
      method: "get",
      controller,
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  const setGroupSort = async ({ groups }) => {
    setIsFetching(true)
    const data = JSON.stringify(groups)
    const response = await studentRequest.sendRequest({
      endpoint: "groups/sort",
      body: data,
      method: "post",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  const joinGroupByCode = async ({ code }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `groups/join/${code}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const getGroupByCode = async (code) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `groups/students/${code}`,
      body: null,
      method: "get",
    })
    setIsFetching(false)
    return response
  }

  const setSelectedGroup = async ({ groupId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `groups/selected/${groupId}`,
      body: null,
      method: "post",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response?.data || null
  }

  const getUserStatus = async ({ groupId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `placement/user/status/${groupId}`,
      body: null,
      method: "get",
    })
    if (!response.success)
      console.log(response.message || "Something went wrong")
    setIsFetching(false)
    return response.data
  }

  return {
    getStudentGroups,
    getSelectedGroup,
    getStudentGroupsSummary,
    setGroupSort,
    joinGroupByCode,
    getGroupByCode,
    setSelectedGroup,
    getUserStatus,
    isFetching,
  }
}

export default useApi
